import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccessData} from "../../../../../store/action/actionHelpers";
import Toast from "../../../../helper/Toast";
import CreateTaskFormView from "./CreateTaskFormView";
import Task from "../../../../../model/task/Task";
import {createTask} from "../../../../../store/action/task/task";

interface IComponentProps {
	/**
	 * On successful created task callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IDispatchProps {
	/**
	 * Crete task.
	 * @param {Task} data
	 */
	createTask: (data: Task, onSuccess: OnSuccessData<Task>, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps;

class CreateTaskForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<CreateTaskFormView onSubmit={this.onSubmit}
								onCancel={this.props.onCancel}
								isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: Task) {
		this.setState({isSubmitting: true}, () => {
			this.props.createTask(
				data,
				() => {
					Toast.success("Task created", "Task creation");
					this.props.onSuccess();
				},
				() => this.setState({isSubmitting: false}, () => Toast.error("Task creation failed", "Task creation"))
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createTask: (data: Task, onSuccess: OnSuccessData<Task>, onFailure: OnFailure) => dispatch(
			createTask(data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(CreateTaskForm);